module.exports = __webpack_public_path__ + "static/img/logo-login.6734a63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-login.png
// module id = 352
// module chunks = 1